import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CTABand } from "@/components/Bits";

export default function ArticleDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/articles/${slug}`).then((r) => setA(r.data)).catch(() => setA({ error: true }));
  }, [slug]);

  if (!a) return <div className="mx-auto max-w-3xl px-4 py-32 text-[#A1A1AA]">Carregando...</div>;
  if (a.error) return <div className="mx-auto max-w-3xl px-4 py-32"><h1 className="font-heading text-2xl text-white">Artigo não encontrado</h1></div>;

  return (
    <div>
      <article className="mx-auto max-w-3xl px-4 py-16 lg:px-8">
        <Link to="/conteudos" className="text-sm text-[#FF5500] hover:underline">← Conteúdos</Link>
        <span className="label-eyebrow mt-6 block text-[#FF5500]">{a.category}</span>
        <h1 className="font-heading mt-3 text-3xl font-black text-white md:text-4xl">{a.title}</h1>
        <img src={a.image} alt={a.title} className="mt-8 aspect-[16/9] w-full border border-[#27272A] object-cover" />
        <div className="mt-8 space-y-4 leading-relaxed text-[#A1A1AA]">
          {a.content.split("\n").filter(Boolean).map((p, i) => <p key={i}>{p}</p>)}
        </div>
      </article>
      <CTABand />
    </div>
  );
}
